(() => {
  const timeout = 5000;
  const interval = 250;

  const maxExecN = timeout / interval;
  let currentExecN = 0;

  const id = setInterval(function () {
    const addonSelect = document.querySelector('.lb-shared-variants-select');

    if (addonSelect) {
      const [sunsetValue, midnightValue] = Array.from(addonSelect.querySelectorAll('option'))
        .slice(1)
        .map((item) => item.value);

      const optionNameToValue = {
        sunrise: sunsetValue,
        midnight: midnightValue,
      };

      const variantInputNode = document.querySelector('.product-form__input');
      variantInputNode.addEventListener('change', function () {
        const name = variantInputNode.querySelector('input:checked')?.value.toLowerCase();
        const value = optionNameToValue[name];

        if (!value) return;

        addonSelect.value = value;
        addonSelect.dispatchEvent(new Event('change'));
      });

      clearInterval(id);
    }

    currentExecN++;
    if (currentExecN > maxExecN) clearInterval(id);
  }, interval);
})();
